import { useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { useDataValue } from 'Simple/Data.js'

import mutation from './mutation.graphql.js'

export default function useDataOnSubmit(props) {
  let appointment = useDataValue({
    context: 'event',
    path: 'appointment',
    viewPath: props.viewPath,
  })
  let [, notify] = useNotifications()
  let setFlowTo = useSetFlowTo(props.viewPath)
  let [, executeMutation] = useMutation(mutation)

  return async function onSubmit({ value }) {
    if (!value.appointment_type_id) return true
    if (value.appointment_type_id === appointment.type.id) return

    let mutationResponse = await executeMutation({
      appointment_id: appointment.id,
      appointment_type_id: value.appointment_type_id,
    })
    if (mutationResponse.error) {
      notify(
        notifyError(
          `There was a problem changing the appointment type. Please try again.`
        )
      )
      return
    }

    notify(notifySuccess(`Appointment type changed!`))
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
